<template>

  <div class="condition-monitoring">
    <monitoring-item
      v-for="(definition, name) in definitions"
      :key="name"
      :name="name"
      :definition="definition"
      :asset="asset"
      @change="save(name, $event)"
    />
  </div>

</template>

<script>
  import MonitoringItem from './monitoring-item'

  export default {
    name: 'condition-monitoring',

    props: [ 'asset' ],

    computed: {
      definitions () {
        const config = this.$store.state.deviceTypes.find(deviceType => deviceType.name === this.asset.deviceType)
        return config ? config.monitoringFunctions : {}
      }
    },

    methods: {
      async save (name, values) {
        this.asset.monitoringConfig[name] = values
        await this.$store.dispatch('updateItem', { modelName: 'assets', item: this.asset })
      }
    },

    components: {
      MonitoringItem
    },
  }
</script>

<style scoped lang="scss">

</style>
